import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ReactComponent as ExpandMoreIcon } from "../../icons/arrow-down-short.svg";
import { MainBox } from "../../theme/global.styles";
import {
  CMMetricItem,
  CMSocialImpact,
  CMSocialImpactItem,
  CMStatisticsAnalytics,
  CMTrackSocialCharts,
  CMSocialImpactCharts,
  CMCards
} from "./statistics-analytics.styles";
import Image from "../image/image.component";
import React, { useEffect, useMemo, useState } from "react";
import { getOrdinal, formatNumberUnits } from "../../Utils/common.utils";
import TrackPerformance from "../auctions/track-performance/track-performance.component";
import { CMSelect } from "../auctions/artist-momentum/artist-momentum.styles";
import TrackStatsChart from "../compare-track/compare-track";
import validator from 'validator';
import CardChartTrackSocial from "../card-chart-track-stats/card-chart-track-stats.component";
import CardChartSocialImpact from "../card-chart-social-impact/card-chart-social-impact.component"
import { useLocation } from 'react-router';
import TinyChartBar from '../tinyChartBar/tinyChartBar.component';
import { dummyChartData, chartStats } from '../tinyChartBar/tinyChartBar.data';
import styled from "styled-components";

const StyledAccordionSummary = styled(AccordionSummary)`
  font-size: inherit;

  @media (min-width: 2000px) {
    font-size: 3vh;

    h3 {
      font-size: 3vh;
    }
    svg {
      width: 2vw;
      height: 3vh;
    }
  }
`;

const StatisticsAnalytics = ({ auction, symbolType, ...props }) => {
  const [expanded, setExpanded] = useState(true);
  const [selectedTrack, setSelectedTrack] = useState(0);
  const [selectedTrackSocial, setSelectedTrackSocial] = useState(0);
  const [selectedTrackGraphs, setSelectedTrackGraphs] = useState(0);
  const [trackOptions, setTrackOptions] = useState([]);
  const [trackOptionsSocial, setTrackOptionsSocial] = useState([]);
  const [trackOptionsGraphs, setTrackOptionsGraphs] = useState([]);
  const [trackOptionsCompareGraphs, setTrackOptionsCompareTrack] = useState([]);
  const [socialImpactMessage, setSocialImpactMessage] = useState("This song has no Social Impact");
  const [socialImpactURL, setSocialImpactURL] = useState(false);
  const [graphMessage, setGraphMessage] = useState("This song has no Track Graphs");
  const [graphURL, setGraphURL] = useState(false);
  const [metricsMessage, setMetricsMessage] = useState("This song has no Stats");
  const [compareTrackMessage, setCompareTrackMessage] = useState("This song has no compare tracks");
  const [comparteTrackError, setCompareTrackMessageError] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const v2 = queryParams.get('v2');

  const { hiddenC } = props
  let tracks = auction?.tracks  ? auction?.tracks : [];
  const [stats, setStats] = useState(tracks[selectedTrack]?.stats1)
  const parseJSON = () => {
    try {
      return stats ? JSON.parse(stats) : null;
    } catch (error) {
      console.error("Error parsing 'in_the_news' data:", error);
      setMetricsMessage("The information in the news is erroneous, verify your information.");
      return null;
    }
  }
  const [statsJson, setStatsJson] = useState(() => parseJSON());
  const [metrics, setMetrics] = useState(statsJson?.obj);
  const [socialMediaData2, setSocialMediaData2] = useState({})
  let Social = tracks[selectedTrackSocial]?.social_impact;
  let Graphs = tracks[selectedTrackGraphs]?.stats2;

  const comapreTrackText = tracks[selectedTrack]?.stats3;

  const formatSocialMedia = () => {
    return {
      "chartmetric": {
      "socialMedia": "Chartmetric",
      "icon": "social-media-logos/chartmetric.png",
      "statistics": {
        "score": {
          "title": "Score",
          "value": metrics?.score
        }
      }
    },
    "tiktok": {
      "socialMedia": "TikTok",
      "icon": "social-media-logos/tiktok.png",
      "statistics": {
        "post": {
          "title": "Posts",
          "value": metrics?.tiktok_counts,
          //"rank":metrics?.tiktok_followers_rank
        },
        "likes": {
          "title": "Likes",
          "value": metrics?.tiktok_top_videos_likes,
          //"rank":metrics?.tiktok_likes_rank,
        },
        "views": {
          "title": "Views",
          "value": metrics?.tiktok_top_videos_views,
          //"rank":metrics?.tiktok_top_video_views_rank,
        },
        /*"postCount": {
          "title": "Post Count",
          "value": metrics?.tiktok_track_posts,
          "rank":metrics?.tiktok_track_posts_rank
        }*/
      }
    },
    "soundCloud": {
      "socialMedia": "Sound Cloud",
      "icon": "social-media-logos/soundCloud.png",
      "statistics": {
        "totalPlays": {
          "title": "Total Plays",
          "value": metrics?.soundcloud_playback_count,
          //"rank":metrics?.ins_followers_rank
        }
      }
    },
    "pandora": {
      "socialMedia": "Pandora",
      "icon": "social-media-logos/pandora.png",
      "statistics": {
        "streams": {
          "title": "Streams",
          "value": metrics?.pandora_lifetime_streams,
          //"rank":metrics?.pandora_lifetime_streams_rank,
        },
        "trackStations": {
          "title": "Track Stations",
          "value": metrics?.pandora_lifetime_stations_added,
          //"rank":metrics?.pandora_lifetime_stations_added_rank,
        }
      }
    },
    "spotify": {
      "socialMedia": "Spotify",
      "icon": "social-media-logos/spotify.png",
      "statistics": {
        "popularity": {
          "title": "Popularity",
          "value": metrics?.sp_popularity,
          //"rank":metrics?.sp_followers_rank
        },
        "playlistReach": {
          "title": "Playlist Reach",
          "value": metrics?.sp_playlist_total_reach,
          //"rank":metrics?.sp_monthly_listeners_rank
        },
        "streams": {
          "title": "Streams",
          "value": metrics?.sp_streams,
          //"rank":metrics?.sp_popularity_rank
        },
        /*"playReach": {
          "title": "Playlist Reach",
          "value": metrics?.sp_playlist_total_reach
        },
        "fanConversation": {
          "title": "Fan Conversation Rate", 
          "value": (metrics?.sp_followers/metrics?.sp_monthly_listeners)*100
        },
        "reach_FollowersRatio": {
          "title": "Reach / Followers Ratio",
          "value":  metrics?.sp_playlist_total_reach/metrics?.sp_followers,
        },*/
      }
    },
    "youtube": {
      "socialMedia": "Youtube",
      "icon": "social-media-logos/youtube.png",
      "statistics": {
        "views": {
          "title": "Views",
          "value": metrics?.youtube_views,
          //"rank":metrics?.youtube_monthly_video_views_rank
        },
        "likes": {
          "title": "Likes",
          "value": metrics?.youtube_likes,
          //"rank":metrics?.ycs_views_rank
        },
        /* "dailyVideoViews": {
           "title": "Daily Video Views",
           "value": metrics?.youtube_daily_video_views,
           "rank":metrics?.youtube_daily_video_views_rank
         },
         "monthlyVideoViews": {
           "title": "Monthly Video Views",
           "value": metrics?.youtube_monthly_video_views,
           "rank":metrics?.youtube_monthly_video_views_rank
         }*/
      }
    },
    "genius": {
      "socialMedia": "Genius",
      "icon": "social-media-logos/genius.png",
      "statistics": {
        "views": {
          "title": "Views",
          "value": metrics?.genius_page_views
        }
      }
    },
    "shazam": {
      "socialMedia": "Shazam",
      "icon": "social-media-logos/shazam.png",
      "statistics": {
        "count": {
          "title": "Count",
          "value": metrics?.shazam_counts
        }
      }
    },
    "deezer": {
      "socialMedia": "Deezer",
      "icon": "social-media-logos/deezer.png",
      "statistics": {
        "playlistReach": {
          "title": "Playlist Reach",
          "value": metrics?.de_playlist_total_reach,
          //"rank":metrics?.deezer_fans_rank
        }
      }
    },
    "line": {
      "socialMedia": "Line Music",
      "icon": "social-media-logos/line.png",
      "statistics": {
        "likes": {
          "title": "Likes",
          "value": metrics?.line_music_likes,
          //"rank":metrics?.line_music_artist_likes_rank
        },
        "listenCount": {
          "title": "Listen Count",
          "value": metrics?.line_music_listen_count,
          //"rank":metrics?.line_music_likes_rank
        },
        /*"plays": {
          "title": "Plays",
          "value": metrics?.line_music_plays,
          "rank":metrics?.line_music_plays_rank
        },
        "musicVideoPlays": {
          "title": "Music Video Plays",
          "value": metrics?.line_music_mv_plays,
          "rank":metrics?.line_music_mv_plays_rank
        }*/
      }
    },
    "melon": {
      "socialMedia": "Melon",
      "icon": "social-media-logos/melon.png",
      "statistics": {
        "likes": {
          "title": "Likes",
          "value": metrics?.melon_likes,
          //"rank":metrics?.melon_artist_fans_rank,
        },
        /*"likes": {
          "title": "Likes",
          "value": metrics?.melon_likes,
          "rank":metrics?.melon_likes_rank,
        },
        "videoLikes": {
          "title": "Video Likes",
          "value": metrics?.melon_video_likes,
          "rank":metrics?.melon_video_likes_rank,
        },
        "videoViews": {
          "title": "Video Views",
          "value": metrics?.melon_video_views,
          "rank":metrics?.melon_video_views_rank,
        }*/
      }
    },
    "airplay": {
      "socialMedia": "Airplay",
      "icon": "social-media-logos/airplay.png",
      "statistics": {
        "spins": {
          "title": "Spins",
          "value": metrics?.airplay_streams,
          //"rank": metrics?.siriusXm_spins_rank,
        },
        /*"radioSpins": {
          "title": "Radio Spins",
          "value": metrics?.radio_spins,
          "rank": metrics?.radio_spins_rank,
        }*/
      }
    }
    }
  }

  useMemo(()=>{
    setStats(tracks[selectedTrack]?.stats1)
  },[])

  useMemo(()=>{
    setStats(tracks[selectedTrack]?.stats1)
  },[selectedTrack])

  useMemo(()=>{
    setStatsJson(parseJSON())
  },[stats])

  useMemo(()=>{
    setMetrics(statsJson?.obj)
  },[statsJson])

  useMemo(()=>{
    setSocialMediaData2(formatSocialMedia)
  },[metrics])


  const [comapreTrackJson, setComapreTrackJson] = useState(() => {
    try {
      return comapreTrackText ? JSON.parse(comapreTrackText) : null;
    } catch (error) {
      console.error("Error parsing JSON:", error.message);
      setCompareTrackMessage('The Compare Tracks information is wrong, please check your information.');
      setCompareTrackMessageError(true);
      return null;
    }
  });


  useEffect(() => {
    try {
      if (!validator.isURL(Social)) {
        setSocialImpactMessage('The social impact information is wrong, please check your URL.');
        setSocialImpactURL(true);
      }
      else {
        setSocialImpactURL(false);
      }
      if (!validator.isURL(Graphs)) {
        setGraphMessage('The Graph information is wrong, please check your URL.');
        setGraphURL(true);
      }
      else {
        setGraphURL(false);
      }
    } catch (error) {
      console.error("Error parsing 'metrics' data:", metrics);
      setMetricsMessage("State information is erroneous.");
    }
  }, [Social, Graphs])

  const handleChange = () => {
    setExpanded((old) => !old);
  };

  // useEffect(() => {
  //     setTimeout(() => {
  //         window.RevisarImagenesRotas();
  //     }, [500]);
  // }, [])


  useEffect(() => {
    if (auction && auction.tracks) {
      const trackIds = new Set();
      
      const optionsSocial = [];
      const trackOptions = [];
      const optionsGraphs = [];
      const optionsCompareGraphs = [];
      
      auction.tracks.forEach((track, index) => {
        if (!trackIds.has(track.id)) {
          trackIds.add(track.id);
          
          const hasSocial = !!track.social_impact; 
          const hasStats1 = !!track.stats1;
          const hasStats2 = !!track.stats2;
          const hasStats3 = !!track.stats3;
  
          if (hasSocial) {
            optionsSocial.push({
              value: String(index),
              label: track.title,
            });
          }
  
          if (hasStats1) {
            trackOptions.push({
              value: String(index),
              label: track.title,
            });
          }
  
          if (hasStats2) {
            optionsGraphs.push({
              value: String(index),
              label: track.title,
            });
          }

          if (hasStats3) {
            optionsCompareGraphs.push({
              value: String(index),
              label: track.title,
            });
          }
        }
      });
  
      setTrackOptions(trackOptions);
      setTrackOptionsSocial(optionsSocial);
      setTrackOptionsGraphs(optionsGraphs);
      setTrackOptionsCompareTrack(optionsCompareGraphs);
    }
  }, [auction]);

  const handleSelectChange = (e, value) => {
    setSelectedTrack(e.target.value);
  };

  const handleSelectChangeS = (e, value) => {
    setSelectedTrackSocial(e.target.value);
  };

  const handleSelectChangeG = (e, value) => {
    setSelectedTrackGraphs(e.target.value);
  };

  //TODO: replace the data with the real data
  //the uv is the filled chart
  //the pv is the stroke_line chart
  //the name is not visible

    const example_chart_data = [
      {
        name: 'Page A',
        uv: 4000,
        pv: 2400
      },
      {
        name: 'Page B',
        uv: 3000,
        pv: 1398
      },
      {
        name: 'Page C',
        uv: 2000,
        pv: 9800
      },
      {
        name: 'Page D',
        uv: 2780,
        pv: 3908
      },
      {
        name: 'Page E',
        uv: 1890,
        pv: 4800
      },
      {
        name: 'Page F',
        uv: 2390,
        pv: 3800
      },
      {
        name: 'Page G',
        uv: 3490,
        pv: 4300
      }
    ]

    const example_chart_data_2 = [
      {
        name: "Aug",
        uv: 900
      },
      {
        name: "Sep",
        uv: 910
      },
      {
        name: "Oct",
        uv: 870
      },
      {
        name: "Nov",
        uv: 880
      },
      {
        name: "Dec",
        uv: 875
      },
      {
        name: "Jan",
        uv: 2390
      },
      {
        name: "Feb",
        uv: 3490
      },
      {
        name: "Mar",
        uv: 2000
      },
      {
        name: "Apr",
        uv: 2780
      },
      {
        name: "Jun",
        uv: 1890
      },
      {
        name: "Jun",
        uv: 2390
      },
      {
        name: "Aug",
        uv: 3490
      }
    ];

    const example_chart_data_3 = [
      {
        name: "Aug",
        uv: 4000
      },
      {
        name: "Sep",
        uv: 3000
      },
      {
        name: "Oct",
        pv: -2000
      },
      {
        name: "Nov",
        uv: 2780
      },
      {
        name: "Dec",
        uv: 1890
      },
      {
        name: "Jan",
        pv: -2390
      },
      {
        name: "Feb",
        uv: 3490
      },
      {
        name: "Mar",
        pv: -2000,
      },
      {
        name: "Apr",
        uv: 2780
      },
      {
        name: "Jun",
        uv: 1890
      },
      {
        name: "Jun",
        pv: -2390
      },
      {
        name: "Aug",
        uv: 3490
      },
      {
        name: "Aug",
        uv: 4000
      },
      {
        name: "Sep",
        uv: 3000
      },
      {
        name: "Oct",
        pv: -2000
      },
      {
        name: "Nov",
        uv: 2780
      },
      {
        name: "Dec",
        uv: 1890
      },
      {
        name: "Jan",
        pv: -2390
      },
      {
        name: "Feb",
        uv: 3490
      },
      {
        name: "Mar",
        pv: -2000
      },
      {
        name: "Apr",
        uv: 2780
      },
      {
        name: "Jun",
        uv: 1890
      },
      {
        name: "Jun",
        pv: -2390
      },
      {
        name: "Aug",
        uv: 3490
      }
    ];

    const example_track_social_charts = [
      {
        icon:"chartmetric",
        title:"Track Score",
        link:"https://www.google.com",
        quantity:"813",
        quantity_past_month:"20",
        difference:"-2"
      },
      {
        icon:"pandora",
        title:"Pandora Streams",
        link:"https://www.google.com",
        quantity:"1789000000",
        quantity_past_month:"178900",
        difference:"-1780"
      },
      {
        icon:"pandora",
        title:"Pandora Track Stations",
        link:"https://www.google.com",
        quantity:"1000",
        quantity_past_month:"178900",
        difference:"0"
      },
      {
        icon:"airplay",
        title:"Pandora Track Stations",
        link:"https://www.google.com",
        quantity:"100",
        quantity_past_month:"178900",
        difference:"1780"
      },
      {
        icon:"spotify",
        title:"Spotify Streams",
        link:"https://www.google.com",
        quantity:"17890000",
        quantity_past_month:"178900",
        difference:"1780"
      },
      {
        icon:"spotify",
        title:"Spotify Popularity",
        link:"https://www.google.com",
        quantity:"17890000",
        quantity_past_month:"178900",
        difference:"1780"
      },
      {
        icon:"youtube",
        title:"Youtube Views",
        link:"https://www.google.com",
        quantity:"17890000",
        quantity_past_month:"178900",
        difference:"0"
      }
      ,
      {
        icon:"youtube",
        title:"Youtube Likes",
        link:"https://www.google.com",
        quantity:"17890000",
        quantity_past_month:"178900",
        difference:"-1780"
      }
    ]

  if (trackOptionsSocial.length === 0 && trackOptionsGraphs.length === 0 && trackOptions.length === 0 && !comapreTrackJson) return null;

  return (
    <CMStatisticsAnalytics>
      <Accordion expanded={expanded}>
        <MainBox className="accordion-title" onClick={handleChange}>
          <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h3>Statistics & Analytics</h3>
          </StyledAccordionSummary>
        </MainBox>
        <AccordionDetails>
          {symbolType && symbolType !== "Catalog" ? (
            trackOptionsSocial.length > 0 ? (
              <MainBox>
                <CMSocialImpact>
                  <h4>Social Impact</h4>
                  {trackOptionsSocial.length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {trackOptionsSocial.length !== 1 && (
                        <CMSelect
                          value={selectedTrackSocial}
                          onChange={handleSelectChangeS}
                        >
                          <option value="" disabled>
                            Select a track
                          </option>
                          {trackOptionsSocial.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </CMSelect>
                      )}
                      {socialImpactURL ? (
                        <h5>
                          {socialImpactMessage}
                        </h5>
                      ) : (
                        <>
                          <div>
                            {socialImpactURL ? (
                              <h5 style={{ marginTop: "30px" }}>
                                {socialImpactMessage}
                              </h5>
                            ) : (
                              <>
                                {Social && (
                                  <>
                                    {!v2 && <Image src={Social} className="CMImageSize" />}
                                    {v2 &&
                                      <CMSocialImpactCharts>
                                        <TinyChartBar
                                          data={dummyChartData}
                                          stats={chartStats}
                                        />
                                        <CMCards>
                                          <CMCards>
                                            <CardChartSocialImpact
                                              icon="spotify"
                                              title="Followers"
                                              quantity="43540000"
                                              quantity_past_month="100000000"
                                              difference="319900"
                                              chart_title="Total"
                                              chart_data={example_chart_data}
                                            />
                                            <CardChartSocialImpact
                                              icon="instagram"
                                              title="Followers"
                                              quantity="88220000"
                                              quantity_past_month="2000000"
                                              difference="-318380"
                                              chart_title="Followers"
                                              chart_data={example_chart_data}
                                            />
                                          </CMCards>
                                          <CMCards>
                                            <CardChartSocialImpact
                                              icon="youtube"
                                              title="Subscribers"
                                              quantity="23600000"
                                              quantity_past_month="100000000"
                                              difference="200000"
                                              chart_title="Subscribers"
                                              chart_data={example_chart_data}
                                            />
                                            <CardChartSocialImpact
                                              icon="tiktok"
                                              title="Followers"
                                              quantity="10400000"
                                              quantity_past_month="10000"
                                              difference="0"
                                              chart_title="Total"
                                              chart_data={example_chart_data}
                                            />
                                          </CMCards>
                                        </CMCards>
                                      </CMSocialImpactCharts>


                                    }

                                  </>

                                )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <p style={{ marginTop: "30px" }}>No Tracks</p>
                  )}

                </CMSocialImpact>
              </MainBox>)
              :
              ("")
          ) : (
            ""
          )}

          {symbolType &&
          ((symbolType === "Part of an album" && auction.tracks.length > 1) ||
            symbolType === "Album") ? (
            <TrackPerformance auction={auction} />
          ) : (
            ""
          )}
          <MainBox
            style={
              symbolType &&
              ((symbolType === "Part of an album" &&
                auction.tracks.length > 1) ||
                symbolType === "Album")
                ? {}
                : { paddingTop: 0 }
            }
          >
            <CMSocialImpact>
              {trackOptions.length > 0 ||  trackOptionsCompareGraphs.length > 0 ? (
             <> 
             <h4>Track(s) Stats</h4>
              {/*<Image src={URLImages.urlStats[0].urlimg} className="CMImageSize" />*/}
                  { trackOptions.length > 0 && trackOptionsSocial.length !== 1 && (
                    <CMSelect
                      value={selectedTrack}
                      onChange={handleSelectChange}
                    >
                      <option value="" disabled>
                        Select a track
                      </option>
                      {trackOptions.map((option, index) => (
                          <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </CMSelect>
                  )}

                  {hiddenC && (
                    <>
                      {comparteTrackError ? (
                        <h5 style={{ marginTop: "30px" }}>
                          {compareTrackMessage}
                        </h5>
                      ) : (
                        <>
                          {comapreTrackJson &&
                            comapreTrackJson?.obj.length > 1 && (
                              <TrackStatsChart trackData={comapreTrackJson} />
                            )}
                        </>
                      )}
                    </>
                  )}

                  <div>
                    {metrics && socialMediaData2 ? (
                      Object.keys(socialMediaData2).map((metric, index) => {
                        return (
                          <SocialImpactItem
                            key={index}
                            data={socialMediaData2[metric]}
                          />
                        );
                      })
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                ""
              )}
              {trackOptionsGraphs.length > 0 ? (
                <>
                  {trackOptionsSocial.length !== 1 && (
                    <CMSelect
                      value={selectedTrackGraphs}
                      onChange={handleSelectChangeG}
                    >
                      <option value="" disabled>
                        Select a track
                      </option>
                      {trackOptionsGraphs.map((option, index) => (
                        <option key={index} value={option.value}>
                        {option.label}
                      </option>
                      ))}
                    </CMSelect>
                  )}
                  {!v2 &&
                    (graphURL ? (
                      <h5 style={{ marginTop: "30px" }}>{graphMessage}</h5>
                    ) : (
                      Graphs && <Image style={{ marginTop: "30px" }} src={Graphs} className="CMImageSize" />
                    ))}
                </>
              ) : (
                ""
              )}
              {/* <Image src={URLImages.urlStats[1].urlimg} className="CMImageSize" />
              <Image src={URLImages.urlStats[2].urlimg} className="CMImageSize" />
              <Image src="track-stats.png" className="CMImageSize" /> */}
            </CMSocialImpact>
            <CMTrackSocialCharts>
              {v2 &&
                example_track_social_charts.map((item) => {
                  return (
                    <CardChartTrackSocial
                      icon={item.icon}
                      title={item.title}
                      link={item.link}
                      quantity={item.quantity}
                      quantity_past_month={item.quantity_past_month}
                      difference={item.difference}
                      chart_data_1={example_chart_data_2}
                      chart_data_2={example_chart_data_3}
                    />
                  );
                })}
            </CMTrackSocialCharts>
          </MainBox>
        </AccordionDetails>
      </Accordion>
    </CMStatisticsAnalytics>
  );
};

const SocialImpactItem = ({ data, ...props }) => {
  const areAllValuesNull = (statistics) => {
    for (let stat in statistics) {
      if (statistics[stat].value !== null) {
        return false;
      }
    }
    return true;
  };

  if (!areAllValuesNull(data.statistics)) {
    return (
      <CMSocialImpactItem>
        {data ? (
          <>
            <div className="social-media-title">
              {data.icon && <Image src={data.icon} />}
              {console.log(data.icon)}
              {data.socialMedia}
            </div>
            <div className="social-media-'metrics?'">
              {data.statistics
                ? Object.keys(data.statistics).map((stat, index) => {
                  const { value, rank, title } = data.statistics[stat];
                  return (
                    <MetricItem
                      key={index}
                      title={title}
                      value={value}
                      rank={rank}
                    />
                  );
                })
                : ""}
            </div>
          </>
        ) : (
          ""
        )}
      </CMSocialImpactItem>
    );
  }
};

const MetricItem = ({ title, icon, value, rank }) => {
  if (value) {
    return (
      <CMMetricItem>
        <div>{title}</div>
        <div className="metric-value">
          {title === "Popularity" ? (
            <>
              {formatNumberUnits(value)}/100
              <span>{rank ? `(${getOrdinal(rank)})` : ""}</span>
            </>
          ) : title === "Fan Conversation Rate" ? (
            <>
              {formatNumberUnits(value)}%
              <span>{rank ? `(${getOrdinal(rank)})` : ""}</span>
            </>
          ) : title === "Reach / Followers Ratio" ? (
            <>
              {formatNumberUnits(value)}x
              <span>{rank ? `(${getOrdinal(rank)})` : ""}</span>
            </>
          ) : (<>
            {formatNumberUnits(value)}
            <span>{rank ? `(${getOrdinal(rank)})` : ""}</span>
          </>)}
        </div>
      </CMMetricItem>
    );
  } else {
    return;
  }

};

export default StatisticsAnalytics;


